import React from 'react';

import NoteIcon from 'icons/note-sm.svg';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

export default function TrainingNotesIcon({ onNotesToggleClick }) {
  return (
    <OutlinedButton color='grey' onClick={onNotesToggleClick} size='xs'>
      <NoteIcon height={16} width={16} />
    </OutlinedButton>
  );
}
